import angular from 'angular';

import CategoryColorComponent from './category-color.cmpt';

export default angular
    .module('application.component.modals.component.category-color', [])
    .component(CategoryColorComponent.selector, CategoryColorComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-color/index.js